var map = {
	"./admin/admin.module.ngfactory": [
		"../../../../../src/$$_gendir/app/dashboard/admin/admin.module.ngfactory.ts",
		"admin.module"
	],
	"./check/check.module.ngfactory": [
		"../../../../../src/$$_gendir/app/dashboard/admin/check/check.module.ngfactory.ts",
		"common",
		"check.module.0"
	],
	"./company/company.module.ngfactory": [
		"../../../../../src/$$_gendir/app/dashboard/admin/company/company.module.ngfactory.ts",
		"common",
		"company.module"
	],
	"./dashboard/dashboard.module.ngfactory": [
		"../../../../../src/$$_gendir/app/dashboard/dashboard.module.ngfactory.ts",
		"common",
		"dashboard.module"
	],
	"./employee/check/check.module.ngfactory": [
		"../../../../../src/$$_gendir/app/dashboard/employee/check/check.module.ngfactory.ts",
		"common",
		"check.module"
	],
	"./employee/employee.module.ngfactory": [
		"../../../../../src/$$_gendir/app/dashboard/admin/employee/employee.module.ngfactory.ts",
		"common",
		"employee.module"
	],
	"./employee/user/user.module.ngfactory": [
		"../../../../../src/$$_gendir/app/dashboard/employee/user/user.module.ngfactory.ts",
		"common",
		"user.module"
	],
	"./notification/notification.module.ngfactory": [
		"../../../../../src/$$_gendir/app/dashboard/admin/notification/notification.module.ngfactory.ts",
		"common",
		"notification.module"
	],
	"./real-time/real-time.module.ngfactory": [
		"../../../../../src/$$_gendir/app/dashboard/admin/check/real-time/real-time.module.ngfactory.ts",
		"common",
		"real-time.module"
	],
	"./reports/reports.module.ngfactory": [
		"../../../../../src/$$_gendir/app/dashboard/admin/check/reports/reports.module.ngfactory.ts",
		"common",
		"reports.module"
	],
	"./times/times.module.ngfactory": [
		"../../../../../src/$$_gendir/app/dashboard/admin/check/times/times.module.ngfactory.ts",
		"common",
		"times.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_gendir lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// /var/www/lantago-app/lantago-app-demo/src/$$_gendir lazy
// module id = ../../../../../src/$$_gendir lazy recursive
// module chunks = main